export class Point {
    constructor(public x: number, public y: number) {
    }

    max(x: number, y: number): Point {
        return new Point(Math.max(this.x, x), Math.max(this.y, y));
    }
}
